import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { render, MARK_LINK, NODE_PARAGRAPH } from 'storyblok-rich-text-react-renderer';
import { getPlainText } from '@storyofams/storyblok-toolkit';
import clsx from 'clsx';
import LinkResolver from '../../helpers/link-resolver';
import Container from '../Container';
import FancyTitle from '../fancy-title';

export default function BlogPostFAQ(faq) {
  const styles = clsx(
    'blok-blogpost-faq',
  );

  const data = faq.blok ? faq.blok : faq;
  const Wrapper = faq.blok ? Container : React.Fragment;

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: data?.faq_items?.map((faqItem) => ({
      '@type': 'Question',
      name: faqItem.Question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: typeof faqItem.Answer === 'string' ? faqItem.Answer : getPlainText(faqItem.Answer),
      },
    })),
  };

  return (
    <Wrapper>
      <div {...storyblokEditable(data)} className={styles}>
        <FancyTitle
          text={data?.title}
          tag="h2"
        />
        {data?.faq_items?.map((faqItem, index) => (
          <details key={faqItem._uid} open={index === 0}>
            <summary className="text-2xl font-bold my-4 cursor-pointer marker:text-latori-green-dark">{faqItem.Question}</summary>
            {typeof faqItem.Answer === 'string' ? (
              <p>{faqItem.Answer}</p>
            ) : (
              render(faqItem.Answer, {
                markResolvers: {
                  [MARK_LINK]: LinkResolver,
                },
                nodeResolvers: {
                  // eslint-disable-next-line react/no-unstable-nested-components
                  [NODE_PARAGRAPH]: (children) => <p className="mt-2">{children}</p>,
                },
              })
            )}
          </details>
        ))}
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </Wrapper>
  );
}
